import React, { useState } from "react";
import { AnimatePresence } from "framer-motion";

import CardComponent from "@/components/Molecules/CardComponent";
import PartnerForm from "@/components/Organisms/PartnerForm";

const AllPackagesSection = ({
  urlsArguments,
  options,
  isYogaPage,
  isNutritionPage,
  isNutritionHomePage,
  defaultTimezone,
  planData,
}) => {
  const [paymentModal, setPaymentModal] = useState(false);
  const [paymentData, setPaymentData] = useState("");

  const setPayment = (data) => {
    setPaymentData(data);
    setPaymentModal(true);
  };

  return (
    <>
      <CardComponent
        planData={planData}
        openPaymentPage={setPayment}
        isNutritionPage={isNutritionHomePage}
      />
      <AnimatePresence>
        {paymentModal && (
          <PartnerForm
            isYogaPage={isYogaPage}
            isNutritionPage={isNutritionPage}
            // URL Arguments
            urlsArguments={urlsArguments}
            showSelectPackage
            showGoalField={false}
            formTitle="Pay Now"
            formSubtitle="Pay now to book your spot - we'll get in touch to set you up"
            defaultPackageSlug="nutrition-callback-others"
            defaultSelectedPack={paymentData}
            // Show Form as Modal
            isCallbackModal={paymentModal}
            setShowCallbackModal={setPaymentModal}
            options={options}
          />
        )}
      </AnimatePresence>
    </>
  );
};

export default AllPackagesSection;
